import { render, staticRenderFns } from "./modelFour.vue?vue&type=template&id=d8c6277c&scoped=true&"
import script from "./modelFour.vue?vue&type=script&lang=js&"
export * from "./modelFour.vue?vue&type=script&lang=js&"
import style0 from "./modelFour.vue?vue&type=style&index=0&id=d8c6277c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8c6277c",
  null
  
)

export default component.exports